import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, useSearchParams, useParams } from 'react-router-dom';

import {
  Container,

  PageHeader,
  NotificBtn,
  ButtonBack,
  BackIcon,
  NotificWrap,
  ChangeButton,
  IconEdit,
  Span,
  TimeBox,
  TimeTitle,
  TimeText,
  Checkbox,
  CustomLabel,
  ShopBox,
  ShopSubBox,
  SetBox,
  IconMenu,
  Container1,
} from './Header.styled';
import { useGetBagsQuery, useGetMonthlyTasksQuery } from '../../../redux/bags/bagsApi';
import { useGetNotificationsQuery } from '../../../redux/notification/notificationApi';
import NotificationModal from 'components/modal/NotificationModal/NotificationModal';
import { useSocket } from '../../../context/SocketContext';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';
import { selectToken } from '../../../redux/auth/selectors';
import OrdersConfirm from 'components/modal/OrdersConfirm/OrdersConfirm';
import ReturnModal from 'components/modal/ReturnModal';
import { url, url1 } from 'components/other/terms';
import LogoutBtn from '../LogoutBtn';
import { socketEventReceived } from '../../../redux/app/appSlice';
import { useFetchShopsQuery, useToggleShopWorkingMutation } from '../../../redux/shops/shopsApi';

import CustomSelect3 from 'components/other/CustomSelect3';
import WorkingHoursModal from 'components/modal/WorkingHoursModal/WorkingHoursModal';
import { showErrorToast, showSuccessToast } from 'utils/showToast';
import { useDispatch } from 'react-redux';
import CustomSelect5 from 'components/other/CustomSelect5';




const Header = ({ openSidebar, isLightTheme, setIsLightTheme }) => {
  const { data: NotiData, isLoading: isLoadingNoti,refetch:refetchNoti } = useGetNotificationsQuery();
  const { data: shopsData, isLoading: isLoadingShop } = useFetchShopsQuery();
const [toggleShopWorking, { isLoading }] =
  useToggleShopWorkingMutation();
  const modalRef = useRef(null);

  const dispatch = useDispatch();
  const socket = useSocket();
  const [shops, setShops] = useState([]);
  const [point, setPoint] = useState(``);
  const [pointObj, setPointObj] = useState(``);
    const [pointId, setPointId] = useState(``);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const token = useSelector(selectToken);
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpenRet, setModalOpenRet] = useState(false);
  const [selectOrderId, setSelectOrderId] = useState(false);
  const [selectOrderCId, setSelectOrderCId] = useState(false);
    const [selectOrderType, setSelectOrderType] = useState(false);
  const [selectArrayOrderId, setSelectArrayOrderId] = useState([]);
  const [isModalOpenOrder, setModalOpenOrder] = useState(false);
    const [isModalOpenTime, setModalOpenTime] = useState(false);
  const [visibleBack, setVisibleBack] = useState(false);
  const [notificationsAr, setNotificationsAr] = useState([]);
  const [markUnRead, setMarkUnRead] = useState(false);
  const [searchParams] = useSearchParams();
  const onboard = searchParams.get('onboard');
  const { shopid: shopIdFromParams } = useParams();  
  const currentPath = location.pathname;
  const lastPage = currentPath.split('/').length - 1 >= 3 ? currentPath.split('/')[currentPath.split('/').length - 2] : currentPath.split('/')[currentPath.split('/').length - 1];
const [isHeaderHidden, setIsHeaderHidden] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  

  const handleCatClick = () => {
  setCatOpen(!catOpen)
  };

useEffect(() => {
  let lastScroll = 0;

  const onScroll = () => {
    const currentScroll = window.scrollY;

    setIsHeaderHidden(currentScroll > 120); // поріг
    lastScroll = currentScroll;
  };

  window.addEventListener('scroll', onScroll);
  return () => window.removeEventListener('scroll', onScroll);
}, []);
  
  // console.log('shopId :>> ', shopIdFromParams);


  /* eslint-disable */
  const [_, currentPage, __, currentDate] = currentPath.split('/');
  /* eslint-enable */

  const handleMessage = (data) => {
    console.log('Message received:', data);
  };

  const handleError = (error) => {
    console.error('WebSocket error:', error);
  };

  useEffect(() => {
    if (!shopsData) return;

    setShops(shopsData);

    // Якщо shopId є у URL і він існує в списку магазинів
    if (shopIdFromParams) {
      const foundShop = shopsData.find(shop => shop.id === Number(shopIdFromParams));
      if (foundShop) {
        setPointObj(foundShop)
        setPoint(`${foundShop.name} (${foundShop.address})`);
        setPointId(foundShop.id);
        return;
      }
    }

    // Якщо shopId нема або неправильний -> ставимо перший магазин
    const first = shopsData[0];
    if (first) {
      setPoint(`${first.name} (${first.address})`);
      setPointId(first.id);
    }

  }, [shopsData, shopIdFromParams]);

  
  // const handlePointChange = (event) => {
  //   const selectedPoint = event;
  //   setPoint(selectedPoint);


  // }
  
  const handlePointChange = (event) => {
    setPoint(event);

    const selectedShop = shopsData.find(s => `${s.name} (${s.address})` === event);

    if (selectedShop) {
      setPointId(selectedShop.id);

      // ✅ Оновлюємо параметр в URL
      lastPage === "options" ? navigate(`/menu/options/${selectedShop.id}`) :navigate(`/menu/${selectedShop.id}`);
    }
  };



  const handleBackClick = () => {
    // Повернення до попередньої сторінки
    navigate(-1);
  };




  useEffect(() => {
    if (!socket) return;

    const handleMessage = (data) => {
      console.log('повідомлення :>> ', data);
  dispatch(socketEventReceived({
    type: 'message',
    payload: data,
  }));

      const parsedCreatedAt = new Date(data.createdAt);
      const newNotification = {
        id: data.id,
        object_id: data.object_id,
        title: data.title,
        type: data.type,
        message: data.message,
        createdAt: isNaN(parsedCreatedAt) ? new Date() : parsedCreatedAt,
        read: data.unread,
      };
      setNotificationsAr(prev => [newNotification, ...prev]);
    };


    const addUniqueItem = (id, type) => {
  setSelectArrayOrderId(prev => {
    const exists = prev.some(item => item.id === id && item.type === type);
    if (exists) return prev;

    return [{ id, type }, ...prev];
  });
};
const handleReceiptOrder = (data) => {
  console.log('повідомленняReceiptOrder :>> ', data);

  dispatch(socketEventReceived({
    type: 'request-receipt',
    payload: data,
  }));
setSelectOrderCId(data.orderId)
  addUniqueItem(data.orderId, 'order');
  handleOpenModalOrder();
};
const handleReceiptDish = (data) => {
  console.log('повідомленняReceiptDish :>> ', data);

  dispatch(socketEventReceived({
    type: 'request-receipt-dish',
    payload: data,
  }));
setSelectOrderCId(data.orderId)
  addUniqueItem(data.orderId, 'dish');
  handleOpenModalOrder();
};
    
    
    
    const handleReturn = (data) => {
      console.log('повідомленняReturn :>> ', data);
        dispatch(socketEventReceived({
    type: 'request-receipt',
    payload: data,
        }));
      setSelectOrderType('bag')
      setSelectOrderId(data.orderId);
      handleOpenModalRet();
    };

    const handleReturnDish = (data) => {
      console.log('повідомленняReturn :>> ', data);
        dispatch(socketEventReceived({
    type: 'request-receipt',
    payload: data,
        }));
      setSelectOrderType('dish');
      setSelectOrderId(data.orderId);
      handleOpenModalRet();
    };

    socket.on('message', handleMessage);
    socket.on('request-receipt', handleReceiptOrder);
    socket.on('dish-request-receipt', handleReceiptDish);
    socket.on('request-return', handleReturn);
     socket.on('dish-request-return', handleReturnDish);
    socket.on('room', handleReturn);

    return () => {
      socket.off('message', handleMessage);
      socket.off('request-receipt', handleReceiptOrder);
      socket.off('dish-request-receipt', handleReceiptDish);
      socket.off('request-return', handleReturn);
      socket.off('dish-request-return', handleReturn);
      socket.off('room', handleReturn);
    };
  }, [socket]);













  useEffect(() => {

    switch (currentPage) {

      case 'main':
        return setActivePage("Головна");
      
      case 'menu':
        return setActivePage("Меню");

      case 'statistics':
        return setActivePage("Статистика");

      case 'financial':
        return setActivePage("Фінанси");

      case 'services':
        return setActivePage("Служба підтримки");

      case 'settings':
        return setActivePage("Налаштування");

      default:
        setActivePage('');
        return;
    }
  }, [currentPage]);

  const handleOpenModal = () => {
    setModalOpen(!isModalOpen);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setModalOpen(false);

    document.body.style.overflow = 'auto';

  };

  const handleOpenModalRet = () => {
    setModalOpenRet(!isModalOpenRet);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModalRet = () => {
    setModalOpenRet(false);

    document.body.style.overflow = 'auto';

  };


  const handleOpenModalOrder = () => {
    setModalOpenOrder(!isModalOpenOrder);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModalOrder = () => {
    setModalOpenOrder(false);

    document.body.style.overflow = 'auto';

  };


  const handleOpenModalTime = () => {

    setModalOpenTime(true);
    console.log('isModalOpenTime :>> ', isModalOpenTime);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModalTime = () => {
    setModalOpenTime(false);

    document.body.style.overflow = 'auto';

  };

   const handlePointWorkingHour = (pointId) => {
  console.log('ewrfdwefrdwefewfdwew :>> ') ;
     handleOpenModalTime();
    document.body.style.overflow = 'auto';

  };

const handlePointWorking = async point => {
  try {
    const response = await toggleShopWorking({
      id: point.id,
      status: point.is_working ? 0 : 1, // орієнтація тільки на обʼєкт
    }).unwrap();

    showSuccessToast(
      response.message || 'Статус роботи оновлено'
    );
  } catch (error) {
    console.error(error);
    showErrorToast(
      error?.data?.message || 'Не вдалося змінити статус роботи'
    );
  }
};
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal();
      }
    };
    const handleClickOutside = (event) => {
      if (isModalOpen && modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    }
    if (isModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('click', handleClickOutside);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isModalOpen]);


  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
         console.log('dfgeEsk:>> ');
        handleCloseModalTime();
      }
    };
    const handleClickOutside = (event) => {

      // if (isModalOpenTime) {
      //   console.log('dfge :>> ');
      //   handleCloseModalTime();
      // }
    }
    if (isModalOpenTime) {
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('click', handleClickOutside);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isModalOpenTime]);





  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModalOrder();
      }
    };
    const handleClickOutside = (event) => {
      if (isModalOpenOrder ) {
        handleCloseModalOrder();
      }
    }
    if (isModalOpenOrder) {
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('click', handleClickOutside);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isModalOpenOrder]);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModalRet();
      }
    };
    const handleClickOutside = (event) => {
      if (isModalOpenRet) {
        handleCloseModalRet();
      }
    }
    if (isModalOpenRet) {
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('click', handleClickOutside);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isModalOpenRet]);



  useEffect(() => {
    const categoryId = searchParams.get('category');
    if (categoryId || lastPage === "archivebags") {
      setVisibleBack(true)
    } else setVisibleBack(false)
    if (lastPage === "edit" || lastPage === "addbag" || lastPage === "viewbag" || lastPage === "vieworder"  || lastPage === "addshop" || lastPage === "addproducts" || lastPage === "addoptions") setVisibleBack(true);
  }, [searchParams, lastPage]);


  useEffect(() => {

    if (NotiData) {

      setNotificationsAr([...NotiData.data])

    }

  }, [NotiData]);



  useEffect(() => {


    // console.log('notificationsAr :>> ', notificationsAr);
    
// console.log('notificationsAr.filter(item => !item.read).length  :>> ', notificationsAr.filter(item => !item.read).length );
    setMarkUnRead(notificationsAr.filter(item => !item.read).length > 0 ? true : false)

  }, [notificationsAr]);



  return (
    <Container>
      < Container1>
      {visibleBack ? <ButtonBack onClick={handleBackClick}><BackIcon />Назад</ButtonBack> :
       <PageHeader >{activePage}</PageHeader>}
      


      {(currentPage === "menu" && lastPage !== "addproducts" && lastPage !== "addoptions") &&
        <ShopBox>
        <CustomSelect5
        id="pickupPoint"
        name="pickupPoint"
        width={"calc(100% - 48px)"}
        options={[...shops.map((shop) => `${shop.name} (${shop.address})`)]}
        selectedValue={point}
        onChange={handlePointChange}
          />
            <SetBox className={catOpen ? "active" : ""} onClick={handleCatClick}>
            <IconMenu className={catOpen ? "active" : ""} />
               </SetBox>
          <ShopSubBox className={catOpen ? "active" : ""}>
       <TimeBox>
          <TimeTitle>Години роботи</TimeTitle>
          {pointObj?.works_from&& pointObj?.works_to &&  <TimeText>
            з {pointObj?.works_from?.slice(0, 5)} до {pointObj?.works_to?.slice(0, 5)}
          </TimeText>}
        </TimeBox>
        <ChangeButton onClick={handlePointWorkingHour} ><IconEdit /> <Span>Редагувати</Span></ChangeButton>
        <TimeTitle>Заклад працює</TimeTitle>
        <Checkbox
            type="checkbox"
            id={`shop-${pointObj.id}`}
          checked={pointObj.is_working}
          disabled={isLoading}
            onChange={() => handlePointWorking(pointObj)}
          />
            <CustomLabel htmlFor={`shop-${pointObj.id}`} />
            </ShopSubBox>
      </ShopBox>
      }
  </Container1> 

      <NotificWrap onClick={handleOpenModal} hide={markUnRead ? 'true' : 'false'}   floating={markUnRead}>
        <NotificBtn />
        
      </NotificWrap>

        {isModalOpen && !isLoadingNoti && (
          <NotificationModal onClose={handleCloseModal} notificationsAr={notificationsAr} setNotificationsAr={setNotificationsAr} markUnRead={markUnRead} setSelectOrderId={setSelectOrderId} handleOpenModalOrder={handleOpenModalOrder} handleOpenModalOrderRet={handleOpenModalRet} />
        )}
        {isModalOpenOrder &&  (
          <OrdersConfirm onClose={handleCloseModalOrder} orderArrayId={selectArrayOrderId} selectOrderCId={selectOrderCId} setSelectArrayOrderId={setSelectArrayOrderId} />
        )}

        {
          isModalOpenRet && (
            <ReturnModal onClose={handleCloseModalRet} orderId={selectOrderId} type={selectOrderType} />
          )
        }
  {
          isModalOpenTime && (
            <WorkingHoursModal onClose={handleCloseModalTime} shopId={pointId} worksFrom={pointObj?.works_from} worksTo={pointObj?.works_to} />
          )
        }

      <LogoutBtn isHovered={true} onboard={onboard} cls={"mob"} />



    </Container>
  );
};

export default Header;
